module.exports = {
  AamiAlt: require("./aami/alt/tokens.string.js"),
  AamiFeature: require("./aami/feature/tokens.string.js"),
  AamiPrimitive: require("./aami/primitive/index.string.js"),
  AamiDefault: require("./aami/tokens.string.js"),
  AanzAlt: require("./aanz/alt/tokens.string.js"),
  AanzFeature: require("./aanz/feature/tokens.string.js"),
  AanzPrimitive: require("./aanz/primitive/index.string.js"),
  AanzDefault: require("./aanz/tokens.string.js"),
  ApiaAlt: require("./apia/alt/tokens.string.js"),
  ApiaFeature: require("./apia/feature/tokens.string.js"),
  ApiaPrimitive: require("./apia/primitive/index.string.js"),
  ApiaDefault: require("./apia/tokens.string.js"),
  AustralianSeniorsAlt: require("./australianSeniors/alt/tokens.string.js"),
  AustralianSeniorsFeature: require("./australianSeniors/feature/tokens.string.js"),
  AustralianSeniorsPrimitive: require("./australianSeniors/primitive/index.string.js"),
  AustralianSeniorsDefault: require("./australianSeniors/tokens.string.js"),
  CotaAlt: require("./cota/alt/tokens.string.js"),
  CotaFeature: require("./cota/feature/tokens.string.js"),
  CotaPrimitive: require("./cota/primitive/index.string.js"),
  CotaDefault: require("./cota/tokens.string.js"),
  EdiAlt: require("./edi/alt/tokens.string.js"),
  EdiFeature: require("./edi/feature/tokens.string.js"),
  EdiPrimitive: require("./edi/primitive/index.string.js"),
  EdiDefault: require("./edi/tokens.string.js"),
  GuAlt: require("./gu/alt/tokens.string.js"),
  GuFeature: require("./gu/feature/tokens.string.js"),
  GuPrimitive: require("./gu/primitive/index.string.js"),
  GuDefault: require("./gu/tokens.string.js"),
  ImanAlt: require("./iman/alt/tokens.string.js"),
  ImanFeature: require("./iman/feature/tokens.string.js"),
  ImanPrimitive: require("./iman/primitive/index.string.js"),
  ImanDefault: require("./iman/tokens.string.js"),
  IngAlt: require("./ing/alt/tokens.string.js"),
  IngFeature: require("./ing/feature/tokens.string.js"),
  IngPrimitive: require("./ing/primitive/index.string.js"),
  IngDefault: require("./ing/tokens.string.js"),
  NibAlt: require("./nib/alt/tokens.string.js"),
  NibFeature: require("./nib/feature/tokens.string.js"),
  NibPrimitive: require("./nib/primitive/index.string.js"),
  NibSage: require("./nib/sage/tokens.string.js"),
  NibSunset: require("./nib/sunset/tokens.string.js"),
  NibDefault: require("./nib/tokens.string.js"),
  NibWarm: require("./nib/warm/tokens.string.js"),
  NsiAlt: require("./nsi/alt/tokens.string.js"),
  NsiFeature: require("./nsi/feature/tokens.string.js"),
  NsiPrimitive: require("./nsi/primitive/index.string.js"),
  NsiDefault: require("./nsi/tokens.string.js"),
  OrbitProtectAlt: require("./orbitProtect/alt/tokens.string.js"),
  OrbitProtectPrimitive: require("./orbitProtect/primitive/index.string.js"),
  OrbitProtectDefault: require("./orbitProtect/tokens.string.js"),
  PricelineAlt: require("./priceline/alt/tokens.string.js"),
  PricelineFeature: require("./priceline/feature/tokens.string.js"),
  PricelinePrimitive: require("./priceline/primitive/index.string.js"),
  PricelineDefault: require("./priceline/tokens.string.js"),
  QantasAlt: require("./qantas/alt/tokens.string.js"),
  QantasFeature: require("./qantas/feature/tokens.string.js"),
  QantasPrimitive: require("./qantas/primitive/index.string.js"),
  QantasDefault: require("./qantas/tokens.string.js"),
  RealAlt: require("./real/alt/tokens.string.js"),
  RealFeature: require("./real/feature/tokens.string.js"),
  RealPrimitive: require("./real/primitive/index.string.js"),
  RealDefault: require("./real/tokens.string.js"),
  SuncorpAlt: require("./suncorp/alt/tokens.string.js"),
  SuncorpFeature: require("./suncorp/feature/tokens.string.js"),
  SuncorpPrimitive: require("./suncorp/primitive/index.string.js"),
  SuncorpDefault: require("./suncorp/tokens.string.js"),
  TidAlt: require("./tid/alt/tokens.string.js"),
  TidFeature: require("./tid/feature/tokens.string.js"),
  TidPrimitive: require("./tid/primitive/index.string.js"),
  TidDefault: require("./tid/tokens.string.js"),
  WorldNomadsAlt: require("./worldNomads/alt/tokens.string.js"),
  WorldNomadsFeature: require("./worldNomads/feature/tokens.string.js"),
  WorldNomadsPrimitive: require("./worldNomads/primitive/index.string.js"),
  WorldNomadsDefault: require("./worldNomads/tokens.string.js"),
  validBrandModes: {
    aami: ["alt", "feature", "default"],
    aanz: ["alt", "feature", "default"],
    apia: ["alt", "feature", "default"],
    australianSeniors: ["alt", "feature", "default"],
    cota: ["alt", "feature", "default"],
    edi: ["alt", "feature", "default"],
    gu: ["alt", "feature", "default"],
    iman: ["alt", "feature", "default"],
    ing: ["alt", "feature", "default"],
    nib: ["alt", "feature", "sage", "sunset", "default", "warm"],
    nsi: ["alt", "feature", "default"],
    orbitProtect: ["alt", "default"],
    priceline: ["alt", "feature", "default"],
    qantas: ["alt", "feature", "default"],
    real: ["alt", "feature", "default"],
    suncorp: ["alt", "feature", "default"],
    tid: ["alt", "feature", "default"],
    worldNomads: ["alt", "feature", "default"]
  },
  tokens: require("./tokens/token-mapping.js")
};